import React, { useState } from 'react';
import ProductMatchInfo from 'src/types/ProductMatcheInfo';
import { useProductMatchesFetch } from 'src/components/ProductDetails/hooks';
import { Sorting } from 'src/types/Sorting';
import MatchDetailsTable from './MatchDetailsTable';
import NoMatchesView from 'src/components/ProductDetails/NoMatchesView/NoMatchesView';
import { useProductDetailsStateContext } from 'src/stateProviders/useProductDetailsStateContext';
import Loading from 'src/components/common/Loading';
import Collapse from 'src/components/common/Collapse';
import ErrorAlert from 'src/components/common/ErrorAlert';

export const defaultMatchDetailsSorting: Sorting<ProductMatchInfo> = {
  field: 'name',
  order: 'ascend',
};

export const SHIFT_MATCH_DETAILS_COUNT = 5;
export const initialPage = 1;
type MatchDetailsProps = {
  isReadOnlyBenchmark: boolean;
  isReadOnlyMatch: boolean;
};

const MatchDetails: React.FC<MatchDetailsProps> = ({ isReadOnlyMatch, isReadOnlyBenchmark }) => {
  const { ownerId, variance, offset, size } = useProductDetailsStateContext();
  const [sorting, setSorting] = useState(defaultMatchDetailsSorting);
  const [{ data, loading, error, total }, { fetchMore: fetchMoreMatches }] = useProductMatchesFetch(
    sorting,
    size || 0,
    ownerId || '',
    variance || '',
    offset || 1
  );
  const loadingMatches: boolean = loading && data === null;
  const header = <h2>{`Matches (${total || 0})`}</h2>;

  return (
    <Collapse header={header} isExpanded={true}>
      <ErrorAlert isVisible={error} errorLabel={'product match details'} />
      <Loading isVisible={loadingMatches} />
      {data !== null && data.length > 0 ? (
        <MatchDetailsTable
          loading={loading}
          sorting={sorting}
          items={data}
          totalItems={total}
          itemsPerPage={SHIFT_MATCH_DETAILS_COUNT}
          getMoreItems={fetchMoreMatches}
          onSortingChange={setSorting}
          permissions={{ isReadOnlyMatch, isReadOnlyBenchmark }}
        />
      ) : (
        <NoMatchesView />
      )}
    </Collapse>
  );
};

export default MatchDetails;
